import { useEffect, useMemo, useState } from "react";

import DirectDepositSetupContent from "../../../Pages/Direct Deposit/direct-deposit-setup-content";

import usePinWheel from "../../../CustomHooks/usePinWheel";

import { useModalContext } from "../../../Contexts/ModalContext";

import { useStakeDebit } from "../../../CustomHooks/Queries";

import { getTransformedPayrollAccounts } from "../../../Utils/api-data-transforms";
import { isSVDApproved } from "../../../Utils/helpers";
import { modalVariants } from "../../../Utils/constants";

import "../../../Pages/Direct Deposit/direct-deposit.scss";
import "../../../Pages/Direct Deposit/direct-deposit-responsive.scss";
import "./direct-deposit-setup.scss";

export default function renderDirectDepositSetup(modalContext, props = {}) {
  const { updateModalComponent, pushModalStack, setModalTitle, setModalVariant, setModalClassName } = modalContext;

  updateModalComponent(() => <DirectDepositSetupModal {...props} />);
  pushModalStack(() => renderDirectDepositSetup(modalContext, props));
  setModalTitle("Direct Deposit");
  setModalVariant(modalVariants.fullScreenDialog);
  setModalClassName("rendering-page-content direct-deposit-setup-modal");
}

function DirectDepositSetupModal({ onSuccess }) {
  const { onModalClose, setModalClassName } = useModalContext();
  const [isPinWheelComponentOpen, setIsPinWheelComponentOpen] = useState(false);

  const { data: stakeDebit } = useStakeDebit();
  const IsSVDApproved = useMemo(() => isSVDApproved(stakeDebit?.data), [stakeDebit?.data]);

  const {
    payrollAccountsData,
    isGettingPayrollLinkToken,
    refetchingPayrollDataWithDebounce,
    GetPayrollLinkToken,
    PinwheelComponent,
  } = usePinWheel(IsSVDApproved, {
    onPinwheelOpen: () => {
      setIsPinWheelComponentOpen(true);
      setModalClassName("d-none");
    },
    onExit: () => {
      setIsPinWheelComponentOpen(false);
      setModalClassName("rendering-page-content direct-deposit-setup-modal");
    },
  });

  const payrollAccounts = useMemo(
    () =>
      getTransformedPayrollAccounts(payrollAccountsData?.data?.data?.accounts).filter(
        (account) => account?.connection_status !== "disconnected",
      ),
    [payrollAccountsData],
  );

  useEffect(() => {
    if (!isPinWheelComponentOpen && !refetchingPayrollDataWithDebounce && payrollAccounts.length > 0) {
      onSuccess?.();
      onModalClose();
    }
  }, [
    isPinWheelComponentOpen,
    refetchingPayrollDataWithDebounce,
    payrollAccounts.length,
    onSuccess,
    onModalClose,
  ]);

  return (
    <div className="direct-deposit anim-ready">
      <PinwheelComponent />
      <div className="dd-empty-state">
        <DirectDepositSetupContent
          onSetupClick={GetPayrollLinkToken}
          isSetupLoading={isGettingPayrollLinkToken}
        />
      </div>
    </div>
  );
}
